import { Component, Input } from '@angular/core';
import { features } from 'src/app/shared/helpers/tenant.features';

@Component({
  selector: 'app-offer-history',
  templateUrl: './offer-history.component.html',
  styleUrls: ['./offer-history.component.scss'],
})
export class OfferHistoryComponent {
  @Input() offer: any;
  @Input() userType: any;
  readonly features = features;

  constructor() {}
}
